$( document ).ready(function() {
  $(".specifications-list-cust h2").wrap("<div class='accordion shopify_explorer_faq__question accordion-close'></div>");
  $(".specifications-list-cust h2").after("<span></span>");
  $(".specifications-list-cust h6").wrap("<div class='container shopify_explorer_faq__answer'></div");
  $("specifications-list-cust .accordion").append("<span></span>");
  $(".specifications-list-cust .accordion").each(function(){
    $(this).next(".container").addBack().wrapAll("<div class='accordian-wrap'></div>");
  });
});

$(document).ready(function() {
  $('.shopify_explorer_faq__question').click(function() {
    var $question = $(this);
    var $answer = $question.next('.shopify_explorer_faq__answer');

    if ($question.hasClass('accordion-open')) {
      $question.removeClass('accordion-open').addClass('accordion-close');
      $answer.slideUp();
    } 
    else {
      $('.shopify_explorer_faq__question').removeClass('accordion-open').addClass('accordion-close');
      $('.shopify_explorer_faq__answer').slideUp();

      $question.removeClass('accordion-close').addClass('accordion-open');
      $answer.slideDown();
    }
  });
});

$(document).ready(function() {
  $('.faqAccordion dt').click(function() {
    var $question = $(this);
    var $answer = $question.next('.faqAccordion dd');

    if ($question.hasClass('accordion-open')) {
      $question.removeClass('accordion-open').addClass('accordion-close');
      $answer.slideUp();
    } 
    else {
      $('.faqAccordion dt').removeClass('accordion-open').addClass('accordion-close');
      $('.faqAccordion dd').slideUp();

      $question.removeClass('accordion-close').addClass('accordion-open');
      $answer.slideDown();
    }
  });
});

// $(document).ready(function() {
//   $('.product_gallery-featured_images-list').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     fade: true,
//     asNavFor: '.product_gallery-thumbnail_images-list'
//   });
//   $('.product_gallery-thumbnail_images-list').slick({
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     asNavFor: '.product_gallery-featured_images-list',
//     dots: false,
//     centerMode: true,
//     focusOnSelect: true
//   });
// });

var myInterval = setInterval(function() {
  if (document.readyState === 'complete' && !window.location.href.includes('sort_by=price-ascending')) {
    clearInterval(myInterval);

    const sortSelect = document.querySelector('.facet-filters.sorting #SortBy');
    if (sortSelect) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', 'price-ascending');
      window.location.href = url.toString();
    }
  }
}, 1000);

